/* @flow */
import AuthActions from 'auth/AuthActions';
import React from 'react';
import JoinSignUpForm from 'join/components/JoinSignUpForm.jsx';
import Heading from 'components/Heading.jsx';
import Image from 'components/Image.jsx';
import { TreasurerSignUp as TreasurerSignUpConstants } from 'payments/constants/CopyConstants.js';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';
import Container from 'components/Container.jsx';
import Copy from 'components/Copy.jsx';
import AuthenticationView from 'auth/components/AuthenticationView.jsx';
import Columns2 from 'components/Columns2.jsx';
import { Roles } from 'user/UserConstants';

import './styles/TreasurerSignUp.scss';

type Props = {
  location: Object,
}

type State = {
  loading: boolean,
};

export default class TreasurerSignUp extends React.Component {
  props: Props;

  state: State = {
    loading: true,
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  }

  componentWillMount() {
    // This handle the case where the user clicks the "sign in"
    // button in the header and is redirected back here.
    AuthActions.checkLoggedIn().then(() => {
      this.context.router.push({
        pathname: '/activities/treasurer/add_bank_account',
        query: this.props.location.query,
      });
    }, () => this.setState({ loading: false }));
  }

  onUserCreate = () => {
    this.context.router.push({
      pathname: '/activities/treasurer/add_bank_account',
      query: this.props.location.query,
    });
  };

  render() {
    if (this.state.loading) {
      return <CenteredLoadingIndicator />;
    }

    return (
      <AuthenticationView size="large" className="TreasurerSignUp">
        <Columns2 reset="tablet">
          <div>
            <Container size="xsmall">
              <Image
                src={require('assets/images/payments/treasurer-signup.svg')}
                className="TreasurerSignUp-image"
              />
              <Heading align="left" level="2">
                {TreasurerSignUpConstants.title}
              </Heading>
              <Copy color="thunder">
                <ul>
                  <li>
                    <p>{TreasurerSignUpConstants.h1}</p>
                  </li>
                  <li>
                    <p>{TreasurerSignUpConstants.h2}</p>
                  </li>
                  <li>
                    <p>{TreasurerSignUpConstants.h3}</p>
                  </li>
                </ul>
              </Copy>
            </Container>
          </div>
          <div>
            <Container size="xsmall">
              <JoinSignUpForm
                onUserCreate={this.onUserCreate}
                role={Roles.TEACHER}
              />
            </Container>
          </div>
        </Columns2>
      </AuthenticationView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/TreasurerSignUp.jsx